<template>
    <li
        @click="tryClose"
        data-notify="container"
        class="alert open"
        :class="[
            { 'alert-with-icon': icon },
            verticalAlign,
            horizontalAlign,
            alertType,
        ]"
        role="alert"
        data-notify-position="top-center"
    >
        <button
            v-if="showClose"
            type="button"
            aria-hidden="true"
            class="close col-xs-1"
            data-notify="dismiss"
            @click="close"
        >
            <i class="tim-icons icon-simple-remove"></i>
        </button>

        <span v-if="icon"
              data-notify="icon"
              :class="['alert-icon', icon]"></span>
        <div data-notify="message">
            <div v-if="title"
                 class="title">
                <b>{{ title }}<br /></b>
            </div>
            <div v-if="message"
                 v-html="message"></div>
            <content-render
                v-if="!message && component"
                :component="component"
            ></content-render>
        </div>
    </li>
</template>

<script setup lang="ts">
import { useNotificationStore } from '@/stores/notifications';

const props = defineProps({
    id: String,
    message: String,
    title: String,
    icon: String,
    verticalAlign: { type: String, default: 'top' },
    horizontalAlign: { type: String, default: 'right' },
    type: { type: String, default: 'info' },
    timeout: { type: Number, default: 5000 },
    showClose: { type: Boolean, default: true },
    closeOnClick: { type: Boolean, default: true },
});

const notificationStore = useNotificationStore();

const alertType = computed(() => `alert-${props.type}`);

const close = () => {
    notificationStore.removeNotification(props.id!);
};

const tryClose = () => {
    if (props.closeOnClick) {
        close();
    }
};

// Автоудаление
setTimeout(close, props.timeout);
</script>
